module.exports = __webpack_public_path__ + "ptc_momoro_C1.13fa4b48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_C1.jpg
// module id = 9POs
// module chunks = 0